
import { defineComponent, Ref, ref, onUnmounted } from 'vue';
import bus from '../bus';
import { ValidationErrorEvent, ValidationErrorEventKey } from './validation-errors.interceptor';
import { ClientMessage } from '@/b2b/shared/api/server-apis';

interface OldAndNewClientMessage extends ClientMessage {
    value?: string;
};

export default defineComponent({
    name: 'WebApiMessage',
    props: {
        id: {
            type: String,
            required: true,
        },
        clearTiming: {
            required: false,
            type: Number,
            default: 2000,
        },
        accumulate: {
            required: false,
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        const messages: Ref<OldAndNewClientMessage[]> = ref([]);
        let clearTimer;

        const clearClearMessagesTimer = (): void => {
            clearTimer && window.clearTimeout(clearTimer);
            clearTimer = null;
        };

        const setClearMessagesTimer = (): void => {
            clearClearMessagesTimer();
            clearTimer = window.setTimeout(() => {
                messages.value = [];
            }, props.clearTiming);
        };

        const onMessages = (validationErrorEvent: ValidationErrorEvent) => {
            if (validationErrorEvent.messagesId === props.id) {
                if (props.accumulate) {
                    messages.value = [...messages.value, ...validationErrorEvent.messages];
                } else {
                    messages.value = validationErrorEvent.messages;
                }
                validationErrorEvent.handled();
                setClearMessagesTimer();
            }
        };

        bus.on(ValidationErrorEventKey, onMessages);

        onUnmounted(() => {
            bus.off(ValidationErrorEventKey, onMessages);
        });

        return {
            messages,
        };
    },
});
